import GenericTemplate from "./genericTemplate";

export default class GlobalGenericTemplate extends GenericTemplate {

}
